import { ICourse } from '@/shared/ICourse';
import { MenuDivider, MenuList } from '@chakra-ui/react';
import { MenuItemDeleteCourse } from './MenuItemDeleteCourse';
import { MenuItemEditCourse } from './MenuItemEditCourse';
import { MenuItemInviteExpert } from './MenuItemInviteExpert';
import { MenuItemNewRepeatedCourse } from './MenuItemNewRepeatedCourse';
import { MenuItemNotifyProvider } from './MenuItemNotifyProvider';
import { MenuItemOpenSharePoint } from './MenuItemOpenSharePoint';
import { MenuItemDeadlines } from './MenuItemDeadlines';
import { MenuItemArchiveCourse } from './MenuItemArchiveCourse';

export const CourseMenuList = (props: {
  course: ICourse;
  onInviteExpert: (course: ICourse) => void;
  onNewRepeatedCourse: (course: ICourse) => void;
  onDeleteCourse: (course: ICourse) => void;
  onUpdateCourse: (course: ICourse) => void;
  onRemindProvider: (course: ICourse) => void;
  onCourseDeadlines: (course: ICourse) => void;
  onArchiveCourse: (course: ICourse) => void;
}) => {
  const { course } = props;

  return (
    <MenuList fontSize='medium' lineHeight={1.5}>
      <MenuItemDeadlines course={course} onCourseDeadlines={props.onCourseDeadlines} />
      <MenuItemNotifyProvider course={course} onRemindProvider={props.onRemindProvider} />
      <MenuItemNewRepeatedCourse course={course} onNewRepeatedCourse={props.onNewRepeatedCourse} />
      <MenuDivider />
      <MenuItemInviteExpert course={course} onInviteExpert={props.onInviteExpert} />
      <MenuDivider />
      <MenuItemEditCourse course={course} onUpdateCourse={props.onUpdateCourse} />
      <MenuItemOpenSharePoint relativeUrl={`Courses/${course.folderName}`} />
      <MenuDivider />
      <MenuItemArchiveCourse course={course} onArchiveCourse={props.onArchiveCourse} />
      <MenuItemDeleteCourse course={course} onDelete={props.onDeleteCourse} />
    </MenuList>
  );
}

